import { SalesRepresentativesAutocompleteItem } from '../../orders/types/salesRepresentativesAutocomplete.types';
import { PageParams } from '../repositories/common/types/createOfflineCommonRepository.types';
import { offlineCustomersRepository } from '../repositories/offlineCustomers.repository';
import { offlineSalesRepresentativeRepository } from '../repositories/offlineSalesRepresentative.repository';
import { OfflineSalesRepresentativeTransformers } from '../transformers/OfflineSalesRepresentative.transformers';
import {
  GeneralRepsPageParams,
  PageOfflineSalesRepresentativesParams,
} from './types/salesRepresentativesRepository.offlineAdapters.types';

const buildGeneralRepsPageParams = ({
  skip,
  limit,
  totalCustomerReps,
  customerRepsInPage,
}: GeneralRepsPageParams): PageParams => ({
  limit: Math.max(limit - customerRepsInPage, 1),
  skip: Math.max(0, skip - totalCustomerReps),
});

const getCustomerReps = async (
  customerId: string,
): Promise<SalesRepresentativesAutocompleteItem[]> => {
  const customer = await offlineCustomersRepository.getById(customerId);
  if (!customer) {
    return [];
  }

  const allReps = customer.salesRepresentatives || [];

  return allReps.map(OfflineSalesRepresentativeTransformers.toSalesRepresentative);
};

const page = async ({ limit, skip, customerId }: PageOfflineSalesRepresentativesParams) => {
  const customerReps = customerId ? await getCustomerReps(customerId) : [];

  const customerRepsForPage = customerReps.slice(skip, skip + limit);
  const generalSkip = Math.max(0, skip - customerReps.length);

  const generalParams = buildGeneralRepsPageParams({
    skip: generalSkip,
    limit,
    totalCustomerReps: customerReps.length,
    customerRepsInPage: customerRepsForPage.length,
  });

  const pageOfflineSalesReps = await offlineSalesRepresentativeRepository.page(generalParams);

  const slotsForGeneralReps = limit - customerRepsForPage.length;
  const customerRepIds = new Set(customerReps.map((rep) => rep.id));

  const generalRepsForPage =
    slotsForGeneralReps > 0
      ? pageOfflineSalesReps.data
          .filter((rep) => !customerRepIds.has(rep.id))
          .map(OfflineSalesRepresentativeTransformers.toSalesRepresentative)
      : [];

  return {
    data: [...customerRepsForPage, ...generalRepsForPage],
    count: customerReps.length + pageOfflineSalesReps.count,
  };
};

export const salesRepresentativesRepositoryOfflineAdapters = {
  page,
};
